import { parseSearchWith, stringifySearchWith } from '@tanstack/react-router';
import { z } from 'zod';

export const parseSearch = parseSearchWith(JSON.parse);
export const stringifySearch = stringifySearchWith(JSON.stringify);

/**
 * Safe string schema for TanStack Router search params (query params).
 * TanStack Router coerces numeric-looking query values to numbers before Zod
 * runs, so bare `z.string()` will reject values like `"123"`. This helper
 * coerces back to a string and falls back to `defaultValue` on anything else;
 * the explicit `<string>` keeps the input type strict for `Link` search props.
 * @see https://github.com/TanStack/router/issues/537
 */
export const searchParam = (defaultValue = '') => z.coerce.string<string>().catch(defaultValue);
